import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconAnimationEaseOut: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconAnimationEaseOut"><Path fillRule="evenodd" clipRule="evenodd" d="M21.1893 4.76516L20.212 4.97727C15.8163 5.93138 12.4988 7.59451 10.0466 10.0467C7.59439 12.499 5.93125 15.8164 4.97715 20.2121L4.76504 21.1894L2.81055 20.7652L3.02266 19.7879C4.03532 15.1225 5.8416 11.4233 8.6324 8.63252C11.4232 5.84172 15.1223 4.03544 19.7878 3.02278L20.765 2.81067L21.1893 4.76516Z" fill="currentColor"/></CentralIconBase>;
});

export default IconAnimationEaseOut;
